import {
    createActions,
    createReducer
} from 'reduxsauce'


/**
 * ACTION TYPES & CREATORS
 */
export const {
    Types,
    Creators
} = createActions({
    asyncToggleLogin: null,
    toggleLogin: null,
    getDistribuidoresSuccess: ['distribuidores'],
    getDistribuidoresFailure: ['errorMessage'],
    asyncGetDistribuidores: ['usuario', 'senha'],
    setDistribuidor: ['distribuidor'],
    asyncSetDistribuidor: ['distribuidor'],
    setUsuario: ['usuario', 'nomePessoa'],
    asyncClearDistribuidor: null,
    clearDistribuidor: null,

    asyncEnviaFotoParaWs: ['imagemBase64', 'usuario', 'id_distribuidor', 'id_requisicao', 'tipo_pagamento', 'id_deposito'],
    enviaFotoParaWsSuccess: null,
    enviaFotoParaWsFailure: ['menssagemDeErro'],

    resetaLogs: null,
    asyncResetaLogs: null,

    asyncEnviaArquivoParaWs: ['arquivo', 'usuario', 'id_distribuidor', 'id_requisicao', 'tipo_pagamento', 'id_deposito'],

    asyncSetFotoAtual: ['foto'],
    setFotoAtual: ['foto'],
    setTipoArquivo: ['tipo'],

    // solicitacoes de deposito V2 do distribuidor (VERSAOSOLICITACAODEPOSITO = 3)
    asyncGetSolicitacoes: ['idRepresentante'],
    getSolicitacoesSuccess: ['versao', 'solicitacoes'],
    getSolicitacoesFailure: ['erroSolicitacoes'],
    setSolicitacao: ['solicitacao', 'tipoPagamento'],
})


/**
 * STATE INICIAL
 */
const SOLICITACOES_INICIAL = {
    versaoSolicitacao: undefined,
    solicitacoes: [],
    loadingSolicitacoes: false,
    erroSolicitacoes: '',
    solicitacaoAtual: undefined,
    tipoPagamento: undefined,
}

const INITIAL_STATE = {
    responseMessage: '',
    menssagemDeErro: '',
    loggedIn: false,
    usuario: '',
    loading: false,
    loadingEnvioFoto: false,
    distribuidorAtual: undefined,
    nomeUsuario: undefined,
    distribuidores: undefined,
    fotoAtual: undefined,
    tipoArquivo: undefined,
    ...SOLICITACOES_INICIAL,
}

/**
 * REDUCER HANDLERS
 */
const toggleLogin = (state = INITIAL_STATE) => {
    return {
        ...state,
        loggedIn: !state.loggedIn,
        distribuidorAtual: undefined,
        fotoAtual: undefined,
        tipoArquivo: undefined,
        ...SOLICITACOES_INICIAL,
    }
}

const asyncGetDistribuidores = (state = INITIAL_STATE) => {
    return {
        ...state,
        distribuidores: [],
        loading: true
    }
}

const getDistribuidoresSuccess = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        distribuidores: action.distribuidores,
        loading: false,
        menssagemDeErro: '',
        loggedIn: true
    }
}

const getDistribuidoresFailure = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        distribuidores: [],
        loading: false,
        menssagemDeErro: action.errorMessage
    }
}

const setDistribuidor = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        distribuidorAtual: {
            IDPESSOA: action.distribuidor.IDPESSOA,
            IDREPRESENTANTE: action.distribuidor.IDREPRESENTANTE,
            USUARIO: action.distribuidor.USUARIO,
            NOMEPESSOA: action.distribuidor.NOMEPESSOA
        }
    }
}

const setUsuario = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        usuario: action.usuario,
        nomeUsuario: action.nomePessoa
    }
}

const clearDistribuidor = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        distribuidorAtual: undefined,
        menssagemDeErro: '',
        responseMessage: '',
        ...SOLICITACOES_INICIAL,
    }
}

const asyncGetSolicitacoes = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        ...SOLICITACOES_INICIAL,
        loadingSolicitacoes: true,
    }
}

const getSolicitacoesSuccess = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadingSolicitacoes: false,
        erroSolicitacoes: '',
        versaoSolicitacao: action.versao,
        solicitacoes: action.solicitacoes,
    }
}

const getSolicitacoesFailure = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadingSolicitacoes: false,
        erroSolicitacoes: action.erroSolicitacoes,
    }
}

const setSolicitacao = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        solicitacaoAtual: action.solicitacao,
        tipoPagamento: action.tipoPagamento,
    }
}

const asyncEnviaFotoParaWs = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadingEnvioFoto: true,
        menssagemDeErro: '',
        responseMessage: ''
    }
}

const enviaFotoParaWsSuccess = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadingEnvioFoto: false,
        responseMessage: 'Envio realizado com sucesso!',
        menssagemDeErro: '',
        fotoAtual: undefined,
        tipoArquivo: undefined,
        // a proxima foto precisa escolher a solicitacao de novo
        solicitacaoAtual: undefined,
        tipoPagamento: undefined,
    }
}

const enviaFotoParaWsFailure = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadingEnvioFoto: false,
        menssagemDeErro: action.menssagemDeErro,
        responseMessage: '',
        fotoAtual: undefined,
        tipoArquivo: undefined
    }
}

const resetaLogs = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        menssagemDeErro: '',
        responseMessage: ''
    }
}

const asyncEnviaArquivoParaWs = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadingEnvioFoto: true,
        menssagemDeErro: '',
        responseMessage: ''
    }
}

const asyncSetFotoAtual = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadingFotoAtual: true,
    }
}

const setFotoAtual = (state = INITIAL_STATE, action) => {

    return {
        ...state,
        loadingFotoAtual: false,
        fotoAtual: action.foto
    }
}

const setTipoArquivo = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        tipoArquivo: action.tipo
    }
}

/**
 * REDUCER
 */
export default createReducer(INITIAL_STATE, {
    [Types.TOGGLE_LOGIN]: toggleLogin,
    [Types.GET_DISTRIBUIDORES_SUCCESS]: getDistribuidoresSuccess,
    [Types.GET_DISTRIBUIDORES_FAILURE]: getDistribuidoresFailure,
    [Types.ASYNC_GET_DISTRIBUIDORES]: asyncGetDistribuidores,
    [Types.SET_DISTRIBUIDOR]: setDistribuidor,
    [Types.SET_USUARIO]: setUsuario,
    [Types.CLEAR_DISTRIBUIDOR]: clearDistribuidor,
    [Types.ASYNC_ENVIA_FOTO_PARA_WS]: asyncEnviaFotoParaWs,
    [Types.ENVIA_FOTO_PARA_WS_SUCCESS]: enviaFotoParaWsSuccess,
    [Types.ENVIA_FOTO_PARA_WS_FAILURE]: enviaFotoParaWsFailure,
    [Types.RESETA_LOGS]: resetaLogs,

    [Types.ASYNC_ENVIA_ARQUIVO_PARA_WS]: asyncEnviaArquivoParaWs,


    [Types.ASYNC_SET_FOTO_ATUAL]: asyncSetFotoAtual,
    [Types.SET_FOTO_ATUAL]: setFotoAtual,

    [Types.SET_TIPO_ARQUIVO]: setTipoArquivo,

    [Types.ASYNC_GET_SOLICITACOES]: asyncGetSolicitacoes,
    [Types.GET_SOLICITACOES_SUCCESS]: getSolicitacoesSuccess,
    [Types.GET_SOLICITACOES_FAILURE]: getSolicitacoesFailure,
    [Types.SET_SOLICITACAO]: setSolicitacao,
})